import type { AlertProps } from '@mui/material';
import { CrossIcon } from '@tix-ticketing/ui-icons/outline';
import { closeSnackbar, enqueueSnackbar } from 'notistack';
import { useIntl } from 'react-intl';
import { IconButton } from '../components/button/icon-button';
function ToastCloseButton({
  onClick
}: Readonly<{
  onClick: () => void;
}>) {
  const intl = useIntl();
  return <IconButton color="monochrome" size="small" onClick={onClick} label={intl.formatMessage({
    id: "common.close",
    defaultMessage: [{
      "type": 0,
      "value": "Close"
    }]
  })} sx={{
    width: 24,
    height: 24,
    padding: '4px'
  }}>
      <CrossIcon />
    </IconButton>;
}
export function showToast({
  title,
  message,
  severity,
  duration = 6000,
  persist
}: {
  title: string;
  message: string;
  severity: AlertProps['severity'];
  duration?: number;
  persist?: boolean;
}) {
  const id = enqueueSnackbar(message, {
    variant: 'toast',
    persist: persist ?? false,
    autoHideDuration: persist ? null : duration,
    alertProps: {
      title: title,
      severity: severity ?? 'info',
      icon: false,
      sx: {
        maxWidth: 480
      },
      action: <ToastCloseButton onClick={() => closeSnackbar(id)} />
    }
  });
  return id;
}